import { combineReducers } from 'redux';
import card from './card/reducer';
import payments from './payments/reducer';
import currentPayment from './currentPayment/reducer';
import giftCard from './giftCard/reducer';
import chargeModal from './chargeModal/reducer';
import isFetching from './isFetching/reducer';
import chargeAmount from './chargeAmount/reducer';
import handoff from './handoff/reducer';

const reducer = combineReducers({
  card,
  payments,
  currentPayment,
  isFetching,
  giftCard,
  chargeModal,
  chargeAmount,
  handoff,
});

export default reducer;
